import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, TextField, Checkbox } from 'material-ui'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as SettingsActions from '../../../state/actions/message-settings'
import * as ATActions from '../../../state/actions/appointment-types'
import './styles.css'
import ModalContent from './ModalContent'
import styles from './styles'
import style from 'material-ui/svg-icons/image/style'

const MessageSettingApptTypePicker = ({
  actions,
  customPostsEligible,
  customSliderType,
  handleAddType,
  handleChange,
  handleRemoveType,
  handleSearch,
  handlePostCheck,
  isSlider,
  listType,
  open,
  searchTerm,
  selectedTypes,
  sliderAppointmentTypes,
  sliderAppointmentTypeIds,
  sliderName,
  showSliderNameInput,
}) => (
  <Dialog
    modal
    open={open}
    actions={actions}
    bodyStyle={styles.dialogBody}
    actionsContainerStyle={styles.dialogActions}
  >
    {showSliderNameInput && (
      <div>
        <span className="sliderTitle sliderDialogTitle">
          New {customSliderType === 'recall' && 'Recall'} Slider Name:
        </span>
        <TextField
          id="slider-creator-name-field"
          onChange={e => handleChange(e)}
          value={sliderName}
        />
      </div>
    )}
    {!!isSlider &&
      customSliderType !== 'recall' &&
      customPostsEligible && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Checkbox
            label="Post Appointment Reminder?"
            onCheck={e => handlePostCheck(e)}
            style={styles.checkbox}
            labelStyle={styles.labelStyles}
          />
        </div>
      )}
    <ModalContent
      handleAddChip={handleAddType}
      handleRemoveChip={handleRemoveType}
      handleSearch={handleSearch}
      listType={listType}
      searchTerm={searchTerm}
      selectedTypes={selectedTypes}
      sliderAppointmentTypeIds={sliderAppointmentTypeIds}
      sliderAppointmentTypes={sliderAppointmentTypes}
    />
  </Dialog>
)

MessageSettingApptTypePicker.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.element),
  customPostsEligible: PropTypes.bool,
  customSliderType: PropTypes.string,
  handleAddType: PropTypes.func,
  handleChange: PropTypes.func,
  handlePostCheck: PropTypes.func,
  handleRemoveType: PropTypes.func,
  handleSearch: PropTypes.func,
  listType: PropTypes.string,
  open: PropTypes.bool,
  searchTerm: PropTypes.string,
  selectedTypes: PropTypes.arrayOf(PropTypes.string),
  sliderAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string),
  sliderAppointmentTypes: PropTypes.objectOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  sliderName: PropTypes.string,
  showSliderNameInput: PropTypes.bool.isRequired,
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...SettingsActions,
      ...ATActions,
    },
    dispatch,
  )

export default connect(null, mapDispatchToProps)(MessageSettingApptTypePicker)



// WEBPACK FOOTER //
// ./src/components/Settings/MessageSettingApptTypePicker/index.js